import { LostItemMaxImageCount } from "./constants"
import { useMobileLayoutProps } from "@/hooks/useMobileLayoutProps"

// ヘッダー/フッターの高さは index.tsx で1度だけ測り、各 View へはこの形で渡す。
export type MobileLayout = ReturnType<
    typeof useMobileLayoutProps<HTMLElement, HTMLElement>
>

/**
 * 追加できる枚数だけ受け取り、超過分は捨てる。
 *
 * ファイル選択は multiple なのでギャラリーから一度に何枚でも選べてしまう。
 * 上限を超えたまま送信すると API の枚数バリデーションで 400 になり、
 * 画面には「報告に失敗しました」としか出ず原因が分からなくなる。
 */
export const takeWithinPhotoLimit = <T>(files: T[], currentCount: number) => {
    const room = Math.max(0, LostItemMaxImageCount - currentCount)
    return {
        accepted: files.slice(0, room),
        rejectedCount: Math.max(0, files.length - room)
    }
}
